//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../no/Builder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectBodyList.js";
import "../no/Section.js";
import "../no/ugmath.js";
import "../no/Section.js";
import "../no/SelectObjectList.js";
import "../no/Features.js";
let d=[[[0,"ApplyEndCut",1,0],[0,"BuiltUpOffset",0,"Features.ShipDesign.BuiltUpOffsetBuilder",0],[0,"DistanceTolerance",1,0],[0,"DoTrimWithoutCopy",1,0],[0,"ReverseDirection",1,0],[0,"SplitDirectionOption",1,0],[1,"TargetBuiltUps",0,"SelectNXObjectList",0],[1,"TargetProfileOrPlates",0,"SelectNXObjectList",0],[0,"TargetType",1,0],[1,"ToolBodies",0,"SelectBodyList",0],[1,"ToolCurves",0,"SelectNXObjectList",0],[1,"ToolCurvesSection",0,"Section",0],[1,"ToolFaces",0,"SelectNXObjectList",0],[0,"ToolNewPlane",1,"Plane",0],[0,"ToolOption",1,0],[0,"ToolVector",1,"Direction",0],[0,"TrimDirection",1,0]],[],[]];
SPLM.Features.ShipDesign.SplitProfilePlateBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.SplitProfilePlateBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.SplitProfilePlateBuilder.ProfileType = Object.freeze({
    "ProfileOrPlate" : "ProfileOrPlate", "BuiltUp" : "BuiltUp"});

SPLM.Features.ShipDesign.SplitProfilePlateBuilder.ToolOptionType = Object.freeze({
    "Plane" : "Plane", "NewPlane" : "NewPlane", "Extrude" : "Extrude", "Body" : "Body"});

SPLM.Features.ShipDesign.SplitProfilePlateBuilder.SplitDirectionOptionType = Object.freeze({
    "PerpendicularToMoldingFace" : "PerpendicularToMoldingFace", "AlongPlaneOrFace" : "AlongPlaneOrFace"});

export default SPLM;